import { getAbsoluteUrl } from '@tmapy/utils';
import { hrefFromURL } from '../utils/hrefFromURL';
export const DEFAULT_SEARCH_TABS = {
    ADRESY: {
        type: 'GeoCode',
        fieldName: 'text',
        id: 'adresy',
        minQueryLength: 1,
        url: 'https://services7.tmapserver.cz/arcgis/rest/services/Locators/cz_adr,cz_ul,cz_ob/GeocodeServer/findAddressCandidates?outFields=label,id,type,typeDescCz,typeDescEn,shpGeoJson&f=geojson&outSR=5514&',
        resultsLimit: 49,
        zoom: 22,
    },
    PARCELY: {
        type: 'GeoCode',
        fieldName: 'text',
        id: 'parcely',
        minQueryLength: 1,
        url: 'https://services7.tmapserver.cz/arcgis/rest/services/Locators/cz_ku,cz_par/GeocodeServer/findAddressCandidates?outFields=label,id,type,typeDescCz,shpGeoJson&f=geojson&outSR=5514&',
        resultsLimit: 49,
    },
    COORDS: {
        type: 'GeoCode',
        fieldName: 'text',
        id: 'coords',
        minQueryLength: 5,
        url: '//cz-services.tmapserver.cz/services/ftext/service.php?source=coord&outFields=shpJson,typeDesc,id,type,lat,lon,x5513,y5513&outSR=5514',
        resultsLimit: 49,
    },
};
const deriveTabStateFromConfig = (config) => {
    const absoluteUrl = getAbsoluteUrl(config.url);
    if (!absoluteUrl) {
        console.error('Search configuration is removed due to missing URL.', config);
        return null;
    }
    const url = hrefFromURL(absoluteUrl);
    let resultsLimit = config.resultsLimit || 100;
    if (resultsLimit > 1000) {
        console.error(`The resultsLimit in '${config.id}' is greater than recommended.`);
        resultsLimit = Math.min(resultsLimit, 3000);
    }
    return { ...config, resultsLimit, url };
};
export const deriveSearchStateFromConfig = (config) => {
    const tabs = (config?.tabs?.map(deriveTabStateFromConfig).filter(Boolean) || []);
    if (config?.addDefaultTabs) {
        const params = {};
        if (config.regionCodes) {
            params.regionCodes = config.regionCodes;
        }
        tabs.unshift({ ...DEFAULT_SEARCH_TABS.COORDS });
        tabs.unshift({ ...DEFAULT_SEARCH_TABS.PARCELY, params });
        tabs.unshift({ ...DEFAULT_SEARCH_TABS.ADRESY, params });
    }
    return { tabs, activeTabId: tabs[0]?.id };
};
//# sourceMappingURL=deriveSearchStateFromConfig.js.map